import * as Website from '../../Config/Website.js';
import * as Splash from './Modules/Splash.js';
import * as IntroThumb from './Modules/IntroThumb.js';
import * as TogglePlanList from './Modules/TogglePlanList.js';
import * as ToggleMap from './Modules/ToggleMap.js';
import * as ToggleMovieStatus from './Modules/ToggleMovieStatus.js';
import * as FadeIn from './Modules/FadeIn.js';
import * as ScrollMap from './Modules/ScrollMap.js';
import * as InfoTabel from './Modules/InfoTabel.js';
import * as ToggleCta from './Modules/ToggleCta.js';

const preinit = () => {

}

const init = () => {
  Splash.init();
  IntroThumb.init();
  TogglePlanList.init();
  ToggleMovieStatus.init();
  ToggleMap.init();
  FadeIn.init();
  ScrollMap.init();
  InfoTabel.init();
  ToggleCta.init();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}